module.exports = __webpack_public_path__ + "img/IMG_9512_FoamcoreMatted.12fc923a.jpg";